export default __webpack_public_path__ + "static/media/faqTitle.d666a9c1.png";